import { reactive } from 'vue';

import type {
  ResolvedSearchParams,
  WidgetAccommodation,
  WidgetCityOption,
  WidgetCustomerInfo,
  WidgetBookingView,
  WidgetError,
  WidgetState,
  WidgetStatus,
} from './types';

export function todayISO(): string {
  const d = new Date();
  return d.toISOString().slice(0, 10);
}

export function shiftDays(iso: string, days: number): string {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function createSearchDefaults(): ResolvedSearchParams {
  const checkIn = todayISO();
  return {
    cityId: null,
    rcId: null,
    cityName: null,
    commonCityId: null,
    checkIn,
    checkOut: shiftDays(checkIn, 1),
    guests: 2,
    children: 0,
    childrenAges: null,
    page: 1,
    pageSize: 12,
  };
}

export function createState(seed?: Partial<ResolvedSearchParams>): WidgetState {
  // Drop undefined seed values before merging — a bare {checkIn: undefined}
  // would otherwise overwrite the sensible defaults (today/today+1) with
  // undefined, which later surfaces as `check_in=undefined` in booking URLs
  // and as a missing `arrival_date` in /search bodies.
  const cleanSeed: Partial<ResolvedSearchParams> = {};
  if (seed) {
    for (const [key, value] of Object.entries(seed)) {
      if (value !== undefined) {
        (cleanSeed as Record<string, unknown>)[key] = value;
      }
    }
  }

  return reactive<WidgetState>({
    status: 'idle' satisfies WidgetStatus,
    search: { ...createSearchDefaults(), ...cleanSeed },
    results: [] as WidgetAccommodation[],
    total: 0,
    page: 1,
    hasMore: false,
    customer: null as WidgetCustomerInfo | null,
    customerCities: [] as WidgetCityOption[],
    booking: null as WidgetBookingView | null,
    error: null as WidgetError | null,
  });
}
